
import React from 'react';

const EditModal = ({ 
  isEditing, 
  setIsEditing, 
  currentCompetition, 
  handleEditInputChange,
  handleUpdateCompetition,
  categories 
}) => {
  const onSubmit = (e) => {
    e.preventDefault();
    handleUpdateCompetition(e);
  };

  // Define competition categories
  const competitionCategories = categories || ['club', 'player', 'coach', 'model'];

  return (
    <div className="fixed inset-0 z-50 bg-black/70 flex items-center justify-center p-4">
      <div className="bg-surface-800 border border-line-strong rounded-xl w-full max-w-2xl shadow-2xl">
        <div className="px-6 py-4 border-b border-line">
          <h2 className="text-lg font-semibold text-white">Edit Competition</h2>
        </div>
        <form onSubmit={onSubmit} className="p-6">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
            <div>
              <label className="field-label">Title *</label>
              <input
                type="text"
                name="title"
                value={currentCompetition.title}
                onChange={handleEditInputChange}
                className="field"
                required
              />
            </div>
            <div>
              <label className="field-label">Start date *</label>
              <input
                type="date"
                name="startDate"
                value={currentCompetition.startDate}
                onChange={handleEditInputChange}
                className="field"
                required
              />
            </div>
            <div>
              <label className="field-label">End date *</label>
              <input
                type="date"
                name="endDate"
                value={currentCompetition.endDate}
                onChange={handleEditInputChange}
                className="field"
                required
              />
            </div>
            <div>
              <label className="field-label">Status *</label>
              <select
                name="status"
                value={currentCompetition.status}
                onChange={handleEditInputChange}
                className="field"
              >
                <option value="draft">Draft</option>
                <option value="active">Active</option>
                <option value="completed">Completed</option>
              </select>
            </div>
            <div>
              <label className="field-label">Category *</label>
              <select
                name="category"
                value={currentCompetition.category}
                onChange={handleEditInputChange}
                className="field"
                required
              >
                <option value="">Select category</option>
                {competitionCategories.map(cat => (
                  <option key={cat} value={cat}>
                    {cat === 'model' ? 'Lifestyle Model' : cat.charAt(0).toUpperCase() + cat.slice(1)}
                  </option>
                ))}
              </select>
            </div>
            <div className="md:col-span-2">
              <label className="field-label">Description</label>
              <textarea
                name="description"
                value={currentCompetition.description}
                onChange={handleEditInputChange}
                className="field min-h-[120px]"
              />
            </div>
          </div>
          <div className="mt-6 flex justify-end gap-2">
            <button
              type="button"
              onClick={() => setIsEditing(false)}
              className="btn-secondary"
            >
              Cancel
            </button>
            <button
              type="submit"
              className="btn-primary"
            >
              Save changes
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default EditModal;
